<template lang="pug">
.page.page--light.pod-cost(v-once)
  bokeh-backdrop.page__backdrop

  .page__inner
    .page__header#introduction
      .container.framed
        .introduction
          img.logo(src="/img/pod-cost/logo.svg" width="275" height="80" alt="Pod C.O.S.T. Program")
          h1.page__title.flex(
            data-aos="fade-down"
            data-aos-anchor="#introduction") Pod C.O.S.T. Program

        el-row.cols(:gutter="80")
          el-col(:md="12")
            .page__description(
              data-aos="fade-right"
              data-aos-anchor="#introduction")
              p Sign up here if you are interested in exploring the C.O.S.T. (Cooperative of Sustainable Transportation) program, to lower your inbound freight expense with consolidated FTL inbounds!
              p As we reach sufficient volume on each route, we will be working with leading transportation partners including TQL and WARP to optimize your inbound freight expense, with faster lead times, and better fill rates.
              p Signing up is NOT a firm commitment, and you will have the opportunity to review pricing before committing to any changes in your supply chain.
            el-button.page__cta(
              type="highlight"
              data-aos="fade-up"
              data-aos-anchor="#introduction"
              @click="signUp"
              title="Sign up now") Sign up now

          el-col(:md="12")
            .illustration(
              data-aos="fade-left"
              data-aos-anchor="#introduction")
              img.hero(
                src="/img/pod-cost/hero.svg"
                width="600"
                height="280"
                alt="Pod C.O.S.T. Program")
</template>

<script>
import { WEBSITE_BASE_URL } from '~/settings'

import BokehBackdrop from '~/components/home/BokehBackdrop'
import PodCostModal from '~/components/modals/PodCostModal'

export default {
  components: {
    BokehBackdrop
  },

  head () {
    return this.$seo.head({
      title: 'Pod C.O.S.T. Program',
      description: 'Sign up here if you are interested in exploring the C.O.S.T. (Cooperative of Sustainable Transportation) program, to lower your inbound freight expense with consolidated FTL inbounds!',
      properties: {
        'og:image': `${WEBSITE_BASE_URL}/img/opengraph/pod-cost.jpg?pod`,
        'og:image:type': 'image/jpeg'
      }
    })
  },

  methods: {
    signUp () {
      this.$amplitude.track('CLICK_SIGN_UP_POD_COST')
      return this
        .$dialogs
        .open({
          component: PodCostModal,
          parent: this
        })
    }
  }
}
</script>

<style lang="scss" scoped>
h1, h2, h3 {
  font-weight: $--font-weight-normal;
}

#introduction {
  padding: 4rem 0;
  overflow: hidden;
  .logo {
    height: 40px;
    width: auto;
  }
  .cols {
    @include media(sm-down) {
      display: flex;
      flex-direction: column-reverse;
    }
  }
  .page__title {
    font-size: 32px;
    margin-top: .25em;
    @include media(sm) {
      font-size: 48px;
    }
  }
  .page__description {
    font-size: 16px;
    margin: 2rem 0;
  }
  .page__cta {
    padding-top: 1.2em;
    padding-bottom: 1.2em;
    min-width: 240px;
    border-radius: 1000px;
  }
  .illustration {
    position: relative;
    margin: 0 0 2rem 0;
    @include media(md) {
      margin: 2rem 0;
    }
    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
